import api from "../config/axios";
import axios from "axios";
import config from "../config/config";

// Check if token is expired
const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (error) {
    console.error('Error parsing token:', error);
    return true;
  }
};

// Get token from localStorage
const getToken = () => {
  return localStorage.getItem("token");
};

// Get refresh token from localStorage
const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

// Set tokens in localStorage
const setTokens = (token, refreshToken) => {
  if (token) localStorage.setItem("token", token);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
};

// Clear all tokens
const clearTokens = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
};

// Refresh token function
export const refreshToken = async () => {
  try {
    const refreshTokenValue = getRefreshToken();
    
    if (!refreshTokenValue) {
      throw new Error("No refresh token available");
    }

    const refreshClient = axios.create({
      baseURL: config.apiBaseUrl,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${refreshTokenValue}`,
        "X-Skip-Auth-Refresh": "true",
      },
      withCredentials: true,
      timeout: 10000,
    });

    const response = await refreshClient.post("/user/refresh-token", {});
    const payload = response?.data?.data ?? response?.data ?? {};

    if (payload.token) {
      setTokens(payload.token, payload.refreshToken);
      return payload.token;
    } else {
      throw new Error("No new token received");
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
    clearTokens();
    throw error;
  }
};

// Validate current authentication status
export const validateAuth = async () => {
  const token = getToken();
  
  if (!token) {
    return { isValid: false, reason: "No token found" };
  }

  if (isTokenExpired(token)) {
    try {
      // Try to refresh the token
      const newToken = await refreshToken();
      return { isValid: true, token: newToken };
    } catch (error) {
      // Refresh failed, user needs to login again
      return { isValid: false, reason: "Token expired and refresh failed" };
    }
  }

  return { isValid: true, token };
};

export const loginUser = async (credentials) => {
  try {
    console.log("Attempting login with:", credentials);

    const response = await api.post("/auth/login", {
      email: credentials.email,
      password: credentials.password,
      role: credentials.role || "ADMIN",
    });

    console.log("Full API Response:", response);

    // Store the token from response
    if (response.data.token) {
      setTokens(response.data.token, response.data.refreshToken);
    }

    return response.data;
  } catch (error) {
    console.error("Detailed login error:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    throw error;
  }
};

// Logout function
export const logoutUser = () => {
  clearTokens();
  // Additional cleanup can be added here
};

// Test the login
export const testAuth = async () => {
  try {
    const result = await loginUser({
      email: "pandit.alabi@devlaps.co",
      password: "Admin123.",
    });
    console.log("Login successful:", result);
    return result;
  } catch (error) {
    console.error("Test auth failed:", error);
    throw error;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getToken();
  return token && !isTokenExpired(token);
};
